import focus from "./focus";
import clickoutside from "./clickoutside";
import contextMenu from "./contextMenu";
import putInDialog from "./putInDialog";
import screen from "./screen";
import dblclick from "./dblclick";
import title from "./title";
import wheelScroll from "./wheelScroll";
import './loading'

function install(Vue){
  Vue.use(focus);
  Vue.use(clickoutside);
  Vue.use(contextMenu);
  Vue.use(putInDialog);
  Vue.use(screen);
  Vue.use(dblclick);
  Vue.use(title);
  Vue.use(wheelScroll);
  // Vue.use(loading)
}

export {
  install,
  focus,
  clickoutside,
  // loading
}
export default install;